"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.mutatorAction('selectShortcutsOption', function selectShortcutsOption(shortcutSet) {
    var optionState = store_1.default();
    optionState.shortcuts = shortcutSet;
});
//# sourceMappingURL=selectShortcutsOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-shortcut-option/lib/data/mutators/selectShortcutsOption.js
// module id = 4972
// module chunks = 2